import StyledSum from "./Sum.Module";
// import styles from "./Sum.Module.css";

function Sum(){
    return(

        <StyledSum>
        <div className="container">
          <div className="container" >
            <section className="sum" >
                <div className="sum__justfy">
                    <h1 className="sum__title" >Summary</h1>
                    <p className="sum__litle" >Data Covid Berdasarkan Global</p>
                </div>
            </section>


            <section  className="sum">
             
                <div className="sum__right">
                    <img  className="sum__image" src="https://i.ibb.co/4ZfHSrk/image-1.png" alt="" />
                </div>

            </section>
            </div>
        </div>


        </StyledSum>
        

    )
}


export default Sum;